import type { AnySQLiteDatabase } from "@-/com.npmjs.expo-sqlite";

/** Native uses an explicit owner; web's leader serializes transaction RPCs. */
export async function runOwnedSqliteTransaction<T>(
  connection: AnySQLiteDatabase,
  operation: (transaction: AnySQLiteDatabase) => Promise<T>,
): Promise<T> {
  const run = async (transaction: AnySQLiteDatabase): Promise<T> => {
    await transaction.execAsync("BEGIN IMMEDIATE");
    try {
      const result = await operation(transaction);
      await transaction.execAsync("COMMIT");
      return result;
    } catch (error) {
      try {
        await transaction.execAsync("ROLLBACK");
      } catch (rollbackError) {
        // oxlint-disable-next-line eslint/preserve-caught-error -- AggregateError.errors retains rollbackError; cause preserves the original transaction failure.
        throw new AggregateError([error, rollbackError], "Transaction and rollback failed", {
          cause: error,
        });
      }
      throw error;
    }
  };
  const scope: unknown = Reflect.get(connection, "withTransactionScope");
  if (typeof scope === "function") {
    return Reflect.apply(scope, connection, [run]);
  }
  return run(connection);
}
